// test
export const templates = state => state.templates;
export const clientApp = state => state.clientApp;
export const peoples = state => state.peoples;
export const autoStep = state => state.autoStep;
export const checkAuth = state => state.checkAuth;
export const isSafe = state => state.isSafe;
export const isAgent = state => state.isAgent;
export const agents = state => state.agents;
